export const certificateRouter = [
  {path: '/certificate',
    name: "certificate",
    redirect: '/certificate/list',
    component: () => import('@/views/layout/ContentMenu'),
    hidden: true,
    children:[
      {
        path: 'list',
        name: "list",
        meta: {
          activename: "list"
        },
        component: () => import('@/views/certificate/list')
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/views/certificate/router.js